import { createContext } from "react";
const DatePickerContextActions = createContext({
  onDateClick() {
  },
  onPrev() {
  },
  onNext() {
  },
  onMonthChanged() {
  }
});
export {
  DatePickerContextActions
};
//# sourceMappingURL=DatePickerContextActions.js.map
